/* Kruikenland: foto volgt de gekozen kleur, keuze 1 of 2 kruiken met eigen kleur, 1 gratis hoes per bestelling */
(function () {
  var HOES_KEY = 'Gratis hoes';
  function fileOf(src) { return (src || '').split('?')[0].split('/').pop().replace(/_\d+x\d*(?=\.)/, ''); }
  function productJson(root) {
    var el = (root || document).querySelector('[data-product-json]') || document.querySelector('[data-product-json]');
    try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; }
  }
  function goToFile(want) {
    var gal = document.querySelector('.pz-gal');
    if (!gal || !want) return false;
    var slides = gal.querySelectorAll('.pz-gal__slide');
    var thumbs = gal.querySelectorAll('[data-pz-gt]');
    var idx = -1;
    Array.prototype.some.call(slides, function (s, i) {
      var img = s.querySelector('img');
      if (img && fileOf(img.getAttribute('src')) === want) { idx = i; return true; }
      return false;
    });
    if (idx >= 0 && thumbs[idx]) { thumbs[idx].click(); return true; }
    return false;
  }
  function showVariantImage(root) {
    var product = productJson(root);
    var idInput = root.querySelector('input[name="id"]');
    if (!product || !idInput) return;
    var variant = product.variants.filter(function (v) { return String(v.id) === String(idInput.value); })[0];
    if (!variant || !variant.featured_media) return;
    var want = fileOf(variant.featured_media.preview_image && variant.featured_media.preview_image.src);
    if (goToFile(want)) return;
    var thumbs = document.querySelectorAll('.pz-gal [data-pz-gt]');
    var idx = variant.featured_media.position ? variant.featured_media.position - 1 : -1;
    if (idx >= 0 && thumbs[idx]) thumbs[idx].click();
  }

  /* ---------- 1 of 2 kruiken ---------- */
  function formOf(el) { return el && el.closest && el.closest('form'); }
  function isDuo(form) {
    var q = form && form.querySelector('[data-kl-offer] input[name="quantity"]:checked');
    return !!(q && q.value === '2');
  }
  function colorLegend() {
    var g = document.querySelector('.option-group--swatch[data-option-group] legend');
    if (!g) return null;
    if (!g.hasAttribute('data-kl-base')) {
      var t = g.firstChild && g.firstChild.nodeType === 3 ? g.firstChild.nodeValue : '';
      g.setAttribute('data-kl-base', t);
    }
    return g;
  }
  function syncDuo(form) {
    if (!form || !form.querySelector('[data-kl-offer]')) return;
    var duo = isDuo(form);
    form.classList.toggle('kl-duo', duo);
    var lg = colorLegend();
    if (lg && lg.firstChild && lg.firstChild.nodeType === 3) {
      var base = lg.getAttribute('data-kl-base') || '';
      lg.firstChild.nodeValue = duo ? base.replace(/:\s*$/, '') + ' 1e kruik: ' : base;
    }
  }
  function setName(fs) {
    var c = fs && fs.querySelector('input:checked');
    var n = fs && fs.querySelector('[data-kl-name]');
    if (c && n) n.textContent = c.value;
  }
  function firstColor(form) {
    var product = productJson(form.closest('[data-product]') || document);
    var idInput = form.querySelector('input[name="id"]');
    var c2 = form.querySelector('[data-kl-color2]');
    if (!product || !idInput || !c2) return null;
    var v = product.variants.filter(function (x) { return String(x.id) === String(idInput.value); })[0];
    var i = parseInt(c2.getAttribute('data-kl-color-index') || '0', 10);
    return v && v.options ? v.options[i] : null;
  }
  /* 2e kleur volgt de 1e tot de klant er zelf een kiest */
  function followFirst(form) {
    var c2 = form && form.querySelector('[data-kl-color2]');
    if (!c2 || c2.hasAttribute('data-kl-touched')) return;
    var name = firstColor(form);
    if (!name) return;
    Array.prototype.forEach.call(c2.querySelectorAll('input[name="kl-color-2"]'), function (r) { if (!r.disabled) r.checked = r.value === name; });
    setName(c2);
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.closest) return;
    if (t.closest('[data-option-group]')) {
      setTimeout(function () { showVariantImage(document); followFirst(formOf(document.querySelector('[data-kl-offer]'))); }, 0);
      return;
    }
    if (t.closest('[data-kl-offer]') && t.name === 'quantity') { syncDuo(formOf(t)); }
    var pick = t.closest('.kl-pick');
    if (pick) {
      if (t.name === 'kl-color-2') pick.setAttribute('data-kl-touched', '');
      setName(pick);
    }
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-kl-show-media]');
    if (!b) return;
    e.preventDefault();
    if (goToFile(fileOf(b.getAttribute('data-kl-show-media')))) {
      var gal = document.querySelector('.pz-gal');
      if (gal && gal.getBoundingClientRect().bottom < 80) gal.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  /* Winkelwagen-inhoud opbouwen (pzf.js roept dit aan bij het toevoegen).
     Eén gratis hoes per bestelling: de hoes staat alleen op de eerste kruik, als "1× kleur". */
  window.KL_cartBody = function (form) {
    var fd = new FormData(form);
    var c2in = form.querySelector('input[name="kl-color-2"]:checked');
    fd.delete('kl-color-2');
    var hKey = 'properties[' + HOES_KEY + ']';
    var h = fd.get(hKey);
    if (h) fd.set(hKey, '1× ' + h);
    if (!form.querySelector('[data-kl-offer]') || !isDuo(form)) return fd;
    var product = productJson(form.closest('[data-product]') || document);
    var id1 = String(fd.get('id') || '');
    var v1 = product && product.variants.filter(function (x) { return String(x.id) === id1; })[0];
    var v2 = v1;
    var c2 = form.querySelector('[data-kl-color2]');
    if (v1 && c2in && c2) {
      var i = parseInt(c2.getAttribute('data-kl-color-index') || '0', 10);
      var want = v1.options.slice(); want[i] = c2in.value;
      v2 = product.variants.filter(function (x) { return x.options.join('|') === want.join('|'); })[0] || v1;
    }
    var id2 = v2 ? String(v2.id) : id1;
    var hv = fd.get(hKey);
    var out = new FormData();
    fd.forEach(function (val, key) {
      if (key === 'id' || key === 'quantity' || key.indexOf('properties[') === 0) return;
      out.append(key, val);
    });
    if (id2 === id1) {
      out.append('id', id1); out.append('quantity', '2');
      if (hv) out.append(hKey, hv);
      return out;
    }
    out.append('items[0][id]', id1); out.append('items[0][quantity]', '1');
    if (hv) out.append('items[0][properties][' + HOES_KEY + ']', hv);
    out.append('items[1][id]', id2); out.append('items[1][quantity]', '1');
    return out;
  };

  /* ?aantal=2 vanaf de homepage: kies meteen de duo-optie */
  try {
    var n = new URLSearchParams(location.search).get('aantal');
    if (n) {
      var r = document.querySelector('[data-kl-offer] input[name="quantity"][value="' + n.replace(/\D/g, '') + '"]');
      if (r) r.checked = true;
    }
  } catch (e) {}
  var offerForm = formOf(document.querySelector('[data-kl-offer]'));
  if (offerForm) { followFirst(offerForm); syncDuo(offerForm); }
})();
